export const terminalTypesEnum = {
  NORMAL: { value: 1, label: 'Normal' },
  DELIVERY: { value: 2, label: 'Delivery' },
}

export const terminalTypes = Object.values(terminalTypesEnum)
